import React, { useState } from "react";
import { Offcanvas, Tab, Nav } from "react-bootstrap";
import "./RightModel.css";

interface RightModelProps {
    show: boolean;
    onClose: () => void;
    ragData: any;
    ingestionStatusData: any;
    title?: string;
    loading?: boolean;
}

const RightModel: React.FC<RightModelProps> = ({ show, onClose, ragData, ingestionStatusData, title = "RAG App Details", loading }) => {
    const [fileActiveTab, setfileActiveTab] = useState<any>("all")
    return (
        <Offcanvas show={show} onHide={onClose} placement="end" className="rag-offcanvas">
            <Offcanvas.Header closeButton className="rag-header">
                <div>
                    <h5 className="rag-title">{ragData?.rag_app_name || "..."}</h5>
                    <p className="rag-subtitle">{title}</p>
                </div>
            </Offcanvas.Header>

            <Offcanvas.Body className="rag-body">
                {loading && <div className="text-center py-4">Loading...</div>}

                {!loading && ragData && (
                    <>
                        {/* Basic Details */}
                        <section className="rag-section">
                            <h6 className="rightmodel-title">Basic Details</h6>
                            <div className="rightmodel-details-grid">
                                <div className="rightmodel-detail-item">
                                    <span className="rightmodel-label">Service Name</span>
                                    <span className="rightmodel-value">{ragData?.servicename}</span>
                                </div>
                                <div className="rightmodel-detail-item">
                                    <span className="rightmodel-label">Business Group</span>
                                    <span className="rightmodel-value">{ragData?.businessgroup}</span>
                                </div>
                                <div className="rightmodel-detail-item">
                                    <span className="rightmodel-label">Function</span>
                                    <span className="rightmodel-value">{ragData?.function}</span>
                                </div>
                                <div className="rightmodel-detail-item">
                                    <span className="rightmodel-label">Status</span>
                                    <span className="rightmodel-value"><span className={`rightmodel-status ${ragData?.rag_app_status.toLowerCase()}`}>{ragData.rag_app_status}</span></span>
                                </div>
                            </div>
                        </section>

                        {/* Tabs */}
                        <Tab.Container defaultActiveKey="additional">
                            <Nav variant="tabs" className="rag-tabs">
                                <Nav.Item>
                                    <Nav.Link eventKey="additional">Additional Info</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="advanced">Advanced</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="result">Result</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="files">Files</Nav.Link>
                                </Nav.Item>
                            </Nav>

                            <Tab.Content className="tab-content-area">
                                <Tab.Pane eventKey="additional">
                                    <div className="rightmodel-info-grid">
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Data Source Type</span>
                                            <span className="rightmodel-value">{ragData?.data_source_type}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Source URL</span>
                                            <span className="rightmodel-value">
                                                <a href={ragData?.source_url} target="_blank" rel="noreferrer" className="url-link">
                                                    {ragData?.source_url}
                                                </a>
                                            </span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">ADLS URL</span>
                                            <span className="rightmodel-value">{ragData?.source_url_adls ? ragData.source_url_adls.split(',').join('\n') : 'None'}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Source Doc Formats</span>
                                            <span className="rightmodel-value">{ragData?.source_doc_formats}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Data Load Frequency</span>
                                            <span className="rightmodel-value">{ragData?.data_load_frequency}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Created By</span>
                                            <span className="rightmodel-value">{ragData?.rag_created_by}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Created Date</span>
                                            <span className="rightmodel-value">{ragData?.rag_created_date_time}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Modified Date</span>
                                            <span className="rightmodel-value">{ragData?.rag_modfied_date_time}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Source Added Date</span>
                                            <span className="rightmodel-value">{ragData?.source_added_date_time}</span>
                                        </div>
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="advanced">
                                    <div className="rightmodel-info-grid">
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Chunk Type</span>
                                            <span className="rightmodel-value">{ragData?.chunk_type}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Vector DB</span>
                                            <span className="rightmodel-value">{ragData?.vector_database_provider}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Chunk Size</span>
                                            <span className="rightmodel-value">{ragData?.chunk_size}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Chunk Overlap</span>
                                            <span className="rightmodel-value">{ragData?.chunk_overlap}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Embedding Model</span>
                                            <span className="rightmodel-value">{ragData?.embedding_model}</span>
                                        </div>
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="result">
                                    <div className="rightmodel-info-grid">
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">{ragData?.vector_database_provider === 'azure_ai_search' ? `Vector Endpoint URL` : `Vector Endpoint Name`}</span>
                                            <span className="rightmodel-value">{ragData?.vector_endpoint_name}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Vector Search Index Name</span>
                                            <span className="rightmodel-value">{ragData?.vector_search_index_name}</span>
                                        </div>
                                        <div className="rightmodel-detail-item">
                                            <span className="rightmodel-label">Databricks Workshop Name</span>
                                            <span className="rightmodel-value">
                                                <a href={ragData?.databricks_workpsace_url} target="_blank" rel="noreferrer" className="url-link">
                                                    {ragData?.databricks_workpsace_url}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="files">
                                    <div className="files-wrapper">

                                        {/* Tabs */}
                                        <div className="file-tabs">
                                            {["all", "succeeded", "failed"].map((tab) => (
                                                <button
                                                    key={tab}
                                                    className={`file-tab-btn ${fileActiveTab === tab ? "active" : ""}`}
                                                    onClick={() => setfileActiveTab(tab)}
                                                >
                                                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                                                </button>
                                            ))}
                                        </div>

                                        {/* File List */}
                                        <div className="file-list">
                                            {(() => {
                                                const filtered =
                                                    fileActiveTab === "succeeded"
                                                        ? ingestionStatusData.filter((f:any) => f.ingestion_status?.toLowerCase() === "success")
                                                        : fileActiveTab === "failed"
                                                            ? ingestionStatusData.filter((f:any) => f.ingestion_status?.toLowerCase() === "failed")
                                                            : ingestionStatusData;

                                                if (!filtered?.length) {
                                                    return <div className="no-items">No files found</div>;
                                                }

                                                return filtered.map((file:any, i:any) => {
                                                    const status = file.ingestion_status?.toLowerCase();
                                                    const isSuccess = status === "success";

                                                    return (
                                                        <div
                                                            key={i}
                                                            className={`file-item ${isSuccess ? "success-bg" : "failed-bg"}`}
                                                        >
                                                            {/* Icon */}
                                                            <div className="file-icon">
                                                                {isSuccess ? (
                                                                    <i className="success-icon">✔</i>
                                                                ) : (
                                                                    <i className="failed-icon">✖</i>
                                                                )}
                                                            </div>

                                                            {/* File name + Layer */}
                                                            <div className="file-info">
                                                                <div className="file-name">{file.source_doc_name}</div>
                                                                <div className="file-layer">{file.target_stage}</div>
                                                            </div>
                                                        </div>
                                                    );
                                                });
                                            })()}
                                        </div>
                                    </div>
                                </Tab.Pane>

                            </Tab.Content>
                        </Tab.Container>
                    </>
                )}

                {!loading && !ragData && (
                    <div className="text-center py-4 text-muted">No ragData available</div>
                )}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default RightModel;
